// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2Er28","footer":"ModalUpdate_footer__1e8S_"};